import React, { lazy } from 'react';
import { SunIcon, SmileIcon, FeatherIcon, BrainIcon, MapIcon, CheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const TRANS_IMG = 'https://cdn.magicpatterns.com/uploads/1Qu9V7GZP1i1FTfbe1MRkR/transformacion.webp';
const wins = [{
  icon: SunIcon,
  text: 'Despertar con energía real cada mañana'
}, {
  icon: SmileIcon,
  text: 'Verte al espejo y reconocerte'
}, {
  icon: FeatherIcon,
  text: 'Sentirte liviana y desinflamada'
}, {
  icon: BrainIcon,
  text: 'Tener claridad mental y buen humor'
}, {
  icon: MapIcon,
  text: 'Saber exactamente qué hacer cada día'
}];
export function TransformationSection() {
  return <section className="w-full bg-crema py-20 sm:py-28" data-id="element-143" data-mp="2994apzk3y20c">
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-4 sm:px-6 lg:grid-cols-2 lg:gap-16" data-id="element-144" data-mp="2968f4hvqfpf2">
        <div data-id="element-145" data-mp="207d3urdtzp4w">
          <Reveal data-id="element-146" data-mp="206v1re4hmgp2">
            <h2 className="font-serif text-3xl font-semibold text-tinta sm:text-4xl lg:text-5xl" data-id="element-147" data-mp="208fvj1iz9vlv">
              Imagina en 30 días...
            </h2>
            <p className="mt-4 text-lg text-tinta/70" data-id="element-148" data-mp="f9995gytqr0w">
              El cambio no llega de golpe. Llega en pequeños gestos diarios que,
              sumados, te devuelven a ti misma.
            </p>
          </Reveal>

          <ul className="mt-8 space-y-4" data-id="element-149" data-mp="abpwumlosobl">
            {wins.map((w, i) => <Reveal as="li" key={w.text} delay={i * 0.08} data-id="element-150" data-mp="a9mwp9qtlet5" data-mpi={i}>
                <div className="flex items-center gap-4 rounded-2xl bg-white p-4 shadow-sm sm:p-5" data-id="element-151" data-mp="y2v9yu08t2i7">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-dorado/15 text-dorado" data-id="element-152" data-mp="1304ym7ft5a4z">
                    <w.icon className="h-5 w-5" strokeWidth={1.7} data-id="element-153" data-mp="p2ym2ulog7o7" />
                  </span>
                  <span className="flex-1 text-base leading-snug text-tinta/90 sm:text-lg" data-id="element-154" data-mp="t4k40ud2jc59">
                    {w.text}
                  </span>
                  <CheckIcon className="h-5 w-5 shrink-0 text-rosa-dark" strokeWidth={2.2} data-id="element-155" data-mp="3dt7vc3fkkizc" />
                </div>
              </Reveal>)}
          </ul>
        </div>

        <Reveal data-id="element-156" data-mp="1fbee6auz8xz2">
          <div className="overflow-hidden rounded-3xl shadow-xl shadow-rosa/15" data-id="element-157" data-mp="1fcz8q0hakgwx">
            <img src={TRANS_IMG} alt="Mujer radiante con vestido blanco de brazos abiertos en un campo de flores al atardecer" className="h-full max-h-[600px] w-full object-cover" loading="lazy" data-id="element-158" data-mp="1ail73gc1ddjt" />
          </div>
        </Reveal>
      </div>
    </section>;
}